export default __webpack_public_path__ + "static/media/model.6f0b51ee.svg";